import { render } from "./WeekSelector.vue?vue&type=template&id=3f1121a6"
import script from "./WeekSelector.vue?vue&type=script&lang=js"
export * from "./WeekSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__